module.exports = __webpack_public_path__ + "img/1fc9b6d.jpg";